import {useState} from "react";
import {useFormContext} from "react-hook-form";
import {css} from "@panda/css";

import {CheckBoxGroupControlled, TextareaField} from "@pg-design/rhf-components-module";
import {Text} from "@pg-design/text-module";

import {useAppSelector} from "../../../../store/hooks";
import {getCheckboxConfigBySource} from "../../../constants/lead/lead_modal_checkbox_options";

interface IQuestionsSlotProps {
    isTwoColumnGrid?: boolean;
}

export const LeadFormQuestionsSlot = ({isTwoColumnGrid}: IQuestionsSlotProps) => {
    const [showMoreOptions, setShowMoreOptions] = useState(false);

    const source = useAppSelector((state) => state.mainLead.source);
    const checkboxConfig = getCheckboxConfigBySource(source);
    const shouldShowAllOptions = checkboxConfig.showAllOptions || showMoreOptions;
    const combinedOptions = shouldShowAllOptions ? [...checkboxConfig.baseOptions, ...checkboxConfig.moreOptions] : checkboxConfig.baseOptions;

    const {watch} = useFormContext();
    const selectedQuestions: string[] = watch("questions") || [];
    const otherOptionSelected = selectedQuestions.some((q) => q === "inny");

    return (
        <>
            <Text variant="body_copy_2" mb={2}>
                Chcę zapytać o:
            </Text>

            <CheckBoxGroupControlled
                name="questions"
                options={combinedOptions}
                checkBoxClassName={css({alignItems: "flex-start"})}
                checkboxListClassName={isTwoColumnGrid ? checkboxGridStyles : undefined}
                checkedMarkColor="#02D054"
            />

            {!checkboxConfig.showAllOptions && (
                <Text className={showMoreOptionsTextStyles} variant="info_txt_1" strong mb={2} onClick={() => setShowMoreOptions(!showMoreOptions)}>
                    {showMoreOptions ? "Mniej tematów" : "Więcej tematów"}
                </Text>
            )}

            {shouldShowAllOptions && otherOptionSelected && (
                <TextareaField className={css({mb: 3})} name="userMessage" placeholder="Wpisz własną wiadomość do dewelopera." />
            )}
        </>
    );
};

const checkboxGridStyles = css({
    md: {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: "0.5rem 1rem"
    }
});

const showMoreOptionsTextStyles = css({
    textDecoration: "underline",
    cursor: "pointer"
});
import {useState} from "react";
import {useFormContext} from "react-hook-form";
import {css} from "@panda/css";

import {CheckBoxGroupControlled, TextareaField} from "@pg-design/rhf-components-module";
import {Text} from "@pg-design/text-module";

import {useAppSelector} from "../../../../store/hooks";
import {getCheckboxConfigBySource} from "../../../constants/lead/lead_modal_checkbox_options";

interface IQuestionsSlotProps {
    isTwoColumnGrid?: boolean;
}

export const LeadFormQuestionsSlot = ({isTwoColumnGrid}: IQuestionsSlotProps) => {
    const [showMoreOptions, setShowMoreOptions] = useState(false);

    const source = useAppSelector((state) => state.mainLead.source);
    const checkboxConfig = getCheckboxConfigBySource(source);
    const shouldShowAllOptions = checkboxConfig.showAllOptions || showMoreOptions;
    const combinedOptions = shouldShowAllOptions ? [...checkboxConfig.baseOptions, ...checkboxConfig.moreOptions] : checkboxConfig.baseOptions;

    const {watch} = useFormContext();
    const selectedQuestions: string[] = watch("questions") || [];
    const otherOptionSelected = selectedQuestions.some((q) => q === "inny");

    return (
        <>
            <Text variant="body_copy_2" mb={2}>
                Chcę zapytać o:
            </Text>

            <CheckBoxGroupControlled
                name="questions"
                options={combinedOptions}
                checkBoxClassName={css({alignItems: "flex-start"})}
                checkboxListClassName={isTwoColumnGrid ? checkboxGridStyles : undefined}
                checkedMarkColor="#02D054"
            />

            {!checkboxConfig.showAllOptions && (
                <Text className={showMoreOptionsTextStyles} variant="info_txt_1" strong mb={2} onClick={() => setShowMoreOptions(!showMoreOptions)}>
                    {showMoreOptions ? "Mniej tematów" : "Więcej tematów"}
                </Text>
            )}

            {shouldShowAllOptions && otherOptionSelected && (
                <TextareaField className={css({mb: 3})} name="userMessage" placeholder="Wpisz własną wiadomość do dewelopera." />
            )}
        </>
    );
};

const checkboxGridStyles = css({
    md: {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: "0.5rem 1rem"
    }
});

const showMoreOptionsTextStyles = css({
    textDecoration: "underline",
    cursor: "pointer"
});
